import { useTranslation } from 'react-i18next';

import type { NumberingSeries } from '~/types/user';

import { AlertDialog, Button, Menu } from '~/components';
import { optionsMenuTriggerStyle } from '~/components/Table/TableRow.css';

import type { DialogHandles, TableActions } from '../NumberingSeriesTable.hooks';

type Props = {
  actions: TableActions;
  dialogHandles: DialogHandles;
  numberingSeries: NumberingSeries;
};

export const NumberingSeriesOptionsCell = ({ actions, dialogHandles, numberingSeries }: Props) => {
  const { t } = useTranslation(['common', 'settings']);

  return (
    <Menu.Root>
      <Menu.Trigger render={<Button aria-label={t('common:actions.openMenu')} className={optionsMenuTriggerStyle} icon="MoreVert" />} />

      <Menu.List>
        <Menu.Item icon="Edit" onClick={() => actions.onEditNameAndType(numberingSeries)}>
          {t('settings:general.numberingSeries.edit.name')}
        </Menu.Item>

        <Menu.Item icon="Edit" onClick={() => actions.onEditFormatAndOptions(numberingSeries)}>
          {t('settings:general.numberingSeries.edit.format')}
        </Menu.Item>

        <AlertDialog.Trigger
          handle={dialogHandles.deleteNumberingSeriesHandle}
          nativeButton={false}
          payload={numberingSeries}
          render={<Menu.Item icon="Trash">{t('settings:general.numberingSeries.delete.title')}</Menu.Item>}
        />
      </Menu.List>
    </Menu.Root>
  );
};
